import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../lib/hoc/withModal';
import { pointActions } from '../../../store/modules/point';
import PointLogModal from '../../../views/point/common/modal/PointLogModal';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';

class PointLogModalContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    this.getList({
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   *  포인트 LOG 가져오기
   */
  getList = (option) => {
    const { getPointLogList, data, pointLog } = this.props;
    const { userId } = data;
    const { pagination } = pointLog;

    getPointLogList({
      userId,
      /**
       *  리스트 pagination
       */
      pagination,
      ...option,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'pointLogModal', value: false });
  };

  render() {
    const { isOpen, pointLog } = this.props;

    return <PointLogModal isOpen={isOpen} pointLog={pointLog} getList={this.getList} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.point.pointLogModal.isOpen,
    data: state.point.pointLogModal.data,
    pointLog: state.point.pointLog,
  };
};

const mapDispatchToProps = {
  getPointLogList: pointActions.getPointLogList,
  toggleModal: pointActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PointLogModalContainer));
